

























import Vue from 'vue'
import loadErrorPng from '../../../../../app/assets/images/web/common/load-error.png'
import BaseImage from '@/common/components/BaseImage.vue'

export default Vue.extend({
  components: {
    BaseImage
  },
  computed: {
    loadErrorImg() {
      return loadErrorPng
    }
  },
  methods: {
    retryHandler(): void {
      this.$emit('retry')
    }
  }
})
